import {createI18n} from 'vue-i18n';

import en from './en.json';
import de from './de.json';
import es from './es.json';

const messages = {
    en: en,
    de: de,
    pt: es,
    es: es,
};

const language = {'de.birchplace.com': 'de'};

const i18n = createI18n({
    locale: language[window.location.hostname] != undefined ? language[window.location.hostname] : 'en', // set locale
    fallbackLocale: 'en', // set fallback locale
    messages,
})


i18n.setLanguage = (lang) => {
    axios.defaults.headers.common['Accept-Language'] = lang;
    document.querySelector('html').setAttribute('lang', lang);
    if (messages[lang] != undefined) {
        if (i18n.mode === 'legacy') {
            i18n.global.locale = lang
        } else {
            i18n.global.locale.value = lang
        }
        messages[lang] = resp.data;
    } else {
        $api.app.getLanguage(lang).then(resp => {
            if (i18n.mode === 'legacy') {
                i18n.global.locale = lang
            } else {
                i18n.global.locale.value = lang
            }
            messages[lang] = resp.data;
        })
    }
    return lang
}

export default i18n;
